<div class="footer-container desktop-container">
  <div class="footer-container__logo">
    <img class="logo" src="/assets/icons/footer/logo-footer.svg" alt="logo"/>

    <span class="text">
      {{ 'footer.years' | translate}}
    </span>
  </div>

  <div class="footer-container__agreements-and-companies">
    <div class="list-agreements">
      <span class="list-agreements__item" routerLink="/agreements/documents">
      {{ 'footer.agreementForStreamers' | translate}}
      </span>

      <span class="list-agreements__item" routerLink="/agreements/privacy-policy">
      {{ 'footer.privacyPolicy' | translate}}
      </span>

      <span class="list-agreements__item" routerLink="/agreements/refund">
      {{ 'footer.refundPolicy' | translate}}
      </span>
    </div>

    <div class="companies">
      <img src="/assets/icons/footer/mastercard.svg" alt="mastercard">
      <img src="/assets/icons/footer/visa.svg" alt="visa">
      <img src="/assets/icons/footer/mts.svg" alt="mts">
      <img src="/assets/icons/footer/qiwi.svg" alt="qiwi">
      <img src="/assets/icons/footer/beeline.svg" alt="beeline">
    </div>
  </div>

  <div class="footer-container__social">
    <div class="title">
      {{ 'footer.contactWithUs' | translate}}
    </div>

    <div class="socials">
      <img (click)="goToLink('https://vk.me/donateall')" src="/assets/icons/footer/social-vk.svg" alt="vk">
      <a href="mailto:INFO@DONATEALL.ONLINE"><img src="/assets/icons/footer/social-mail.svg" alt="mail"></a>
    </div>
  </div>
</div>

<div class="footer-container-mobile">
  <div class="footer-container__logo">
    <img class="logo" src="/assets/icons/footer/logo-footer.svg" alt="logo"/>
  </div>

  <div class="footer-container__social">
    <div class="title">
      {{ 'footer.contactWithUs' | translate}}
    </div>

    <div class="socials">
      <img src="/assets/icons/footer/social-vk.svg" alt="vk">
      <img src="/assets/icons/footer/social-mail.svg" alt="mail">
    </div>
  </div>

  <div class="footer-container__agreements-and-companies">
    <div class="list-agreements">
      <span class="list-agreements__item" routerLink="/agreements/documents">
      {{ 'footer.agreementForStreamers' | translate}}
      </span>


      <span class="list-agreements__item" routerLink="/agreements/privacy-policy">
      {{ 'footer.privacyPolicy' | translate}}
      </span>

      <span class="list-agreements__item" routerLink="/agreements/refund">
      {{ 'footer.refundPolicy' | translate}}
      </span>
    </div>

    <div class="companies">
      <img src="/assets/icons/footer/mastercard.svg" alt="mastercard">
      <img src="/assets/icons/footer/visa.svg" alt="visa">
      <img src="/assets/icons/footer/mts.svg" alt="mts">
      <img src="/assets/icons/footer/qiwi.svg" alt="qiwi">
      <img src="/assets/icons/footer/beeline.svg" alt="beeline">
    </div>

    <span class="text">
      {{ 'footer.years' | translate}}
    </span>
  </div>
</div>
